import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import ManualFormTitleStrip from "../../../../../common_components/ManualFormTitleStrip";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { formatAmount, toastError, toastSuccess } from "../../../../../utils/constants";
// import { MeetingRoomsList } from "../../../../../utils/dummyJson";
import {
  getMeetingRoomDetails_action,
  insertUpdateMeetingRoom_action,
} from "../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/meetingRoom_action/meetingRoom_action";
import Modal from "react-modal";
import { data } from "jquery";
import $ from "jquery";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import moment from "moment";
import ConfirmationModal from "../../../../../common_components/confirmationa_modal";
import VendorDrawer from "../../../../../common_components/vendor_module_drawer";
//
class MeetingRoomRequestForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmationObj: { message: '', buttonName: '', action: '' },
      popArg: [],
      isOpenConfirmationModal: false,
      isLoading: false,
      PowerConnectionList: [],
      Is_Agree: false,
      Remark: "",
      CGST: "",
      SGST: "",
      Is_AgreeErr: "",
      DeadlineDate: "",
      Is_Required: true,
      carPassessId: "",
      currentDate: moment().format("DD-MM-YYYY"),
      meetingRoomsList: [],
      comboSlots: [],
      totalAmount: 0,
      currency: "",
      CGST: "",
      SGST: "",
      IGST: "",
      is_View: props.isFromSummary ? true : false,
      StatusID: "",
      isHideSection: sessionStorage.getItem("RoleIDSS") != 1 && sessionStorage.getItem("RoleIDSS") != 8,
      // isHideSection: props.isFromSummary ? true : false,
      IsIGST: false
    };
    // this.getPowerConnectionList = this.getPowerConnectionList.bind(this)

    this.handleConfirmation = this.handleConfirmation.bind(this)
  }


  handleConfirmation(flag) {
    const { confirmationObj, popArg } = this.state;
    if (flag) {
      if (confirmationObj.action == 0) {
        this.insertUpdateMeetingRoom()
      }
    }
    this.setState({ isOpenConfirmationModal: false })
  }

  componentDidMount() {
    this.setState({
      DeadlineDate:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.Deadline != ""
          ? moment(this.props.location.state.Deadline).format("DD-MM-YYYY")
          : "",
      is_View: this.props.isFromSummary ? true : (
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.is_View != null
          ? this.props.location.state.is_View
          : sessionStorage.getItem("RoleIDSS") != 1
      ),
      StatusID:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.StatusID != null
          ? this.props.location.state.StatusID
          : "",
    });

    this.getMeetingRoomDetails();
    this.loadscript();
    console.log("this.props.location.state", this.props.location.state)
  }

  loadscript() {
    $(document).ready(function () {
      $(this).scrollTop(0);
    });
  }

  handleCancel() {
    window.history.back();
  }

  inputValidate() {
    const { Is_Agree } = this.state;

    if (Is_Agree == 0 || Is_Agree == false) {
      this.setState({
        Is_AgreeErr: "kindly agree the above mentioned clauses & consequences",
      });
    }
  }

  insertUpdateMeetingRoom() {
    const {
      Remark,
      Is_Agree,
      totalAmount,
      meetingRoomsList,
    } = this.state;
    console.log("meetingRoomsList-->", meetingRoomsList)
    const array = [];
    meetingRoomsList.forEach(item => {
      if (item.timeSlot[0].selected) {
        array.push({
          MstMeetingRoomID: item.timeSlot[0].MstMeetingRoomID
        })
      }
    })

    this.inputValidate();

    const ManualFormsID = this.props.location.state?.ManualFormsID || null;
    const ServiceID = this.props.location.state?.ServiceID || null;
    const VendorDetails = this.props.location.state?.VendorDetails || {};
    this.setState({ isLoading: true });
    if (Is_Agree == true) {
      this.props
        .insertUpdateMeetingRoom_action(totalAmount, Remark, Is_Agree, array, ManualFormsID,
          ServiceID, VendorDetails)
        .then((data) => {
          if (data.error != 1) {
            this.setState({ isLoading: false });
            toastSuccess(this.state.StatusID == 0 ? 'Meeting Room Form Submitted Successfully' : 'Meeting Room Form Updated Successfully')
            setTimeout(() => {
              this.props.navigate('/manualForms')
            }, 2000);
          } else {
            this.setState({ isLoading: false });
            toastError(data.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      toastError("Plase Enter mandatory feilds!");
      this.inputValidate();
      this.setState({ isLoading: false });
    }
  }

  getMeetingRoomDetails() {
    const { Remark, Is_Agree, isQuantity, Is_Required } = this.state;
    this.setState({ isLoading: true });
    this.props
      .getMeetingRoomDetails_action()
      .then((data) => {
        if (data.error != 1) {
          this.setState({
            isLoading: false,
            CGST: data.data[0][0]["CGST"],
            SGST: data.data[0][0]["SGST"],
            IGST: data.data[0][0]["IGST"],
            IsIGST: data.data[0][0]["IsIGST"],
            currency: data.data[0][0]["CurrencyName"],
            Remark: data.data[2]?.[0]?.["Remark"] || '',
            Is_Agree: data.data[2]?.[0]?.["IsAgree"] || false,
            comboSlots: data.data[4] || [],
            meetingRoomsList: this.groupMeetingRooms(data.data[1], data.data[0][0]["CurrencyName"] == 'INR' ? 1 : 0, data.data[3], data.data[4] || []),
          }, () => {
            // Apply combo after state is set (currency is available)
            const { meetingRoomsList, comboSlots } = this.state;
            const list = [...meetingRoomsList];
            this.applyComboSlots(list, comboSlots);
            let totalAmount = 0;
            list.forEach(room => { if (room.timeSlot[0].selected) totalAmount += Number(room.timeSlot[0].rate); });
            this.setState({ meetingRoomsList: list, totalAmount });
          });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  groupMeetingRooms = (data, currencyID, selectedRooms = [], comboSlots = []) => {
    const formatTime = (time) => {
      return `${moment.utc(time).format("hh:mm A")}`;
    };

    // Create a Set of selected meeting room IDs
    const selectedRoomIds = new Set(
      selectedRooms.map((item) => item.MstMeetingRoomID)
    );

    let totalAmount = 0; // <-- Total of selected rooms

    const tree = {};

    data.forEach((item) => {
      const date = moment.utc(item.Date).format("DD-MM-YYYY");

      const rate = currencyID === 1 ? item.RateInINR : item.RateInUSD;
      const isSelected = selectedRoomIds.has(item.MstMeetingRoomID);

      // Calculate total amount
      if (isSelected) {
        totalAmount += Number(rate || 0);
      }

      if (!tree[date]) tree[date] = {};

      if (!tree[date][item.RoomTypeName]) {
        tree[date][item.RoomTypeName] = {};
      }

      if (!tree[date][item.RoomTypeName][item.SeatingCapacity]) {
        tree[date][item.RoomTypeName][item.SeatingCapacity] = {};
      }

      if (!tree[date][item.RoomTypeName][item.SeatingCapacity][item.Location]) {
        tree[date][item.RoomTypeName][item.SeatingCapacity][item.Location] = [];
      }

      tree[date][item.RoomTypeName][item.SeatingCapacity][item.Location].push({
        time: `${formatTime(item.FromTime)} - ${formatTime(item.ToTime)}`,
        rate,
        originalRate: rate,
        MstMeetingRoomID: item.MstMeetingRoomID,
        FromTime: item.FromTime,
        ToTime: item.ToTime,
        SeatingCapacity: item.SeatingCapacity,
        selected: isSelected,
        comboApplied: false,
        comboRate: 0,
      });
    });

    const result = [];

    Object.keys(tree).forEach((date) => {
      const roomTypes = tree[date];

      let dateRows = 0;

      Object.values(roomTypes).forEach((seatings) => {
        Object.values(seatings).forEach((locations) => {
          Object.values(locations).forEach((slots) => {
            dateRows += slots.length;
          });
        });
      });

      let datePrinted = false;

      Object.keys(roomTypes).forEach((roomType) => {
        const seatings = roomTypes[roomType];

        let roomRows = 0;

        Object.values(seatings).forEach((locations) => {
          Object.values(locations).forEach((slots) => {
            roomRows += slots.length;
          });
        });

        let roomPrinted = false;

        Object.keys(seatings).forEach((seating) => {
          const locations = seatings[seating];

          let seatingRows = 0;

          Object.values(locations).forEach((slots) => {
            seatingRows += slots.length;
          });

          let seatingPrinted = false;

          Object.keys(locations).forEach((location) => {
            const slots = locations[location];

            let locationPrinted = false;

            slots.forEach((slot) => {
              result.push({
                date: datePrinted ? "" : date,
                dateRowSpan: datePrinted ? 0 : dateRows,

                RoomTypeName: roomPrinted ? "" : roomType,
                roomTypeRowSpan: roomPrinted ? 0 : roomRows,

                seatingCapacity: seatingPrinted ? "" : seating,
                seatingRowSpan: seatingPrinted ? 0 : seatingRows,

                location: locationPrinted ? "" : location,
                locationRowSpan: locationPrinted ? 0 : slots.length,

                timeSlot: [slot],
              });

              datePrinted = true;
              roomPrinted = true;
              seatingPrinted = true;
              locationPrinted = true;
            });
          });
        });
      });
    });

    // Update total amount
    this.setState({ totalAmount: totalAmount });

    return result;
  };

  applyComboSlots = (meetingRoomsList, comboSlots) => {
    // Reset combo values
    meetingRoomsList.forEach((room) => {
      const slot = room.timeSlot?.[0];

      if (!slot) return;

      slot.rate = slot.originalRate;
      slot.comboApplied = false;
      slot.comboRate = 0;

      slot.comboRowSpan = 1;
      slot.hideComboCell = false;

      slot.amountRowSpan = 1;
      slot.hideAmountCell = false;
    });

    if (!comboSlots || comboSlots.length === 0) {
      return;
    }

    // ---------------------------------------------------------
    // IMPORTANT:
    // Normalize both dates to YYYY-MM-DD
    // Handles:
    // API date       -> 2026-12-04
    // Display date   -> 04-12-2026
    // ---------------------------------------------------------
    const normalizeDate = (date) => {
      if (!date) return "";

      // Already display format: DD-MM-YYYY
      if (
        typeof date === "string" &&
        /^\d{2}-\d{2}-\d{4}$/.test(date)
      ) {
        return moment
          .utc(date, "DD-MM-YYYY", true)
          .format("YYYY-MM-DD");
      }

      // API ISO date
      return moment.utc(date).format("YYYY-MM-DD");
    };

    const normalizeText = (value) =>
      String(value || "")
        .trim()
        .toLowerCase();

    // ---------------------------------------------------------
    // Carry forward grouped row values
    // because groupMeetingRooms() uses blank cells for rowspan
    // ---------------------------------------------------------
    let currentDate = "";
    let currentRoomType = "";
    let currentSeating = "";
    let currentLocation = "";

    const enrichedList = meetingRoomsList.map((room, index) => {
      if (room.date) {
        currentDate = room.date;
      }

      if (room.RoomTypeName) {
        currentRoomType = room.RoomTypeName;
      }

      if (room.seatingCapacity) {
        currentSeating = room.seatingCapacity;
      }

      if (room.location) {
        currentLocation = room.location;
      }

      return {
        room,
        index,
        date: currentDate,
        roomType: currentRoomType,
        seating: currentSeating,
        location: currentLocation,
        slot: room.timeSlot?.[0]
      };
    });

    // ---------------------------------------------------------
    // Group by:
    // Date + RoomType + SeatingCapacity + Location
    // ---------------------------------------------------------
    const groups = {};

    enrichedList.forEach((item) => {
      const key = [
        normalizeDate(item.date),
        normalizeText(item.roomType),
        normalizeText(item.seating),
        normalizeText(item.location)
      ].join("|");

      if (!groups[key]) {
        groups[key] = [];
      }

      groups[key].push(item);
    });

    // ---------------------------------------------------------
    // Apply combo for each group
    // ---------------------------------------------------------
    Object.values(groups).forEach((entries) => {
      if (!entries.length) return;

      const first = entries[0];

      const groupDate = normalizeDate(first.date);
      const groupRoomType = normalizeText(first.roomType);
      const groupSeating = normalizeText(first.seating);
      const groupLocation = normalizeText(first.location);

      const groupKey = [
        groupDate,
        groupRoomType,
        groupSeating,
        groupLocation
      ].join("|");

      console.log("GROUP KEY =>", groupKey);

      // -------------------------------------------------------
      // Find combo
      // -------------------------------------------------------
      const combo = comboSlots.find((item) => {
        const comboDate = normalizeDate(item.Date);
        const comboRoomType = normalizeText(item.RoomTypeName);
        const comboSeating = normalizeText(item.SeatingCapacity);
        const comboLocation = normalizeText(item.Location);

        const comboKey = [
          comboDate,
          comboRoomType,
          comboSeating,
          comboLocation
        ].join("|");

        console.log("COMBO KEY =>", comboKey);

        return comboKey === groupKey;
      });

      console.log("MATCHED COMBO =>", combo);

      if (!combo) {
        return;
      }

      // -------------------------------------------------------
      // Combo configuration
      // -------------------------------------------------------
      const comboHours = Number(combo.ComboSlotHours) || 0;

      if (comboHours <= 0) {
        return;
      }

      const comboRate =
        this.state.currency === "INR"
          ? Number(combo.RateInINR) || 0
          : Number(combo.RateInUSD) || 0;

      // Only selected slots
      const selected = entries.filter(
        (item) => item.slot?.selected
      );

      if (selected.length < 2) {
        return;
      }

      // -------------------------------------------------------
      // Find consecutive selected slots whose total duration
      // exactly matches combo hours.
      //
      // IMPORTANT:
      // We are NOT checking actual timestamp back-to-back.
      // We use consecutive selected rows as requested.
      // -------------------------------------------------------
      let i = 0;

      while (i < selected.length) {
        let totalHours = 0;
        let j = i;

        while (j < selected.length) {
          const slot = selected[j].slot;

          if (!slot) {
            break;
          }

          const from = moment.utc(slot.FromTime);
          const to = moment.utc(slot.ToTime);

          if (!from.isValid() || !to.isValid()) {
            break;
          }

          const hours = moment
            .duration(to.diff(from))
            .asHours();

          totalHours += hours;

          console.log("COMBO HOURS =>", {
            id: slot.MstMeetingRoomID,
            from: from.format("HH:mm"),
            to: to.format("HH:mm"),
            hours,
            totalHours,
            comboHours
          });

          if (totalHours === comboHours) {
            break;
          }

          if (totalHours > comboHours) {
            break;
          }

          j++;
        }

        // -----------------------------------------------------
        // Exact combo duration found
        // -----------------------------------------------------
        if (
          j < selected.length &&
          totalHours === comboHours
        ) {
          const firstSelected = selected[i];
          const lastSelected = selected[j];

          const firstIndex = firstSelected.index;
          const lastIndex = lastSelected.index;

          const rowSpan =
            lastIndex - firstIndex + 1;

          const firstSlot = firstSelected.slot;

          // First row gets combo price
          firstSlot.rate = comboRate;
          firstSlot.comboRate = comboRate;
          firstSlot.comboApplied = true;

          firstSlot.comboRowSpan = rowSpan;
          firstSlot.amountRowSpan = rowSpan;

          // Hide combo/amount cells for rows covered
          // by the combo rowspan
          for (
            let index = firstIndex + 1;
            index <= lastIndex;
            index++
          ) {
            const slot =
              meetingRoomsList[index]?.timeSlot?.[0];

            if (!slot) continue;

            slot.hideComboCell = true;
            slot.hideAmountCell = true;
          }

          // Other selected rows inside combo should have
          // zero amount because first row contains combo price
          for (
            let k = i + 1;
            k <= j;
            k++
          ) {
            const slot = selected[k].slot;

            slot.rate = 0;
            slot.comboApplied = true;
          }

          console.log("COMBO APPLIED =>", {
            comboID: combo.MeetingRoomComboSlotID,
            comboRate,
            comboHours,
            firstIndex,
            lastIndex,
            groupKey
          });

          i = j + 1;
        } else {
          i++;
        }
      }
    });
  };

  handleSlotChange = (index) => {
    const meetingRoomsList = [...this.state.meetingRoomsList];

    meetingRoomsList[index].timeSlot[0].selected =
      !meetingRoomsList[index].timeSlot[0].selected;

    this.applyComboSlots(meetingRoomsList, this.state.comboSlots);

    let totalAmount = 0;
    const selectedSlots = [];

    meetingRoomsList.forEach((room) => {
      const slot = room.timeSlot[0];

      if (slot.selected) {
        totalAmount += Number(slot.rate);

        selectedSlots.push({
          date: room.date,
          roomType: room.RoomTypeName,
          seatingCapacity: room.seatingCapacity,
          location: room.location,
          slot: slot.time,
          rate: slot.rate,
        });
      }
    });

    this.setState({
      meetingRoomsList,
      totalAmount: parseInt(totalAmount),
      selectedSlots,
    });
  };

  render() {
    const {
      isLoading,
      Is_Agree,
      Remark,
      Is_AgreeErr,
      currentDate,
      DeadlineDate,
      meetingRoomsList,
      totalAmount,
      currency,
      CGST,
      SGST,
      IGST,
      is_View,
      StatusID, isOpenConfirmationModal,
      isHideSection, IsIGST
    } = this.state;
    const isDeadlinePassed =
      DeadlineDate &&
      moment(DeadlineDate, "DD-MM-YYYY") &&
      moment(currentDate, "DD-MM-YYYY").isAfter(moment(DeadlineDate, "DD-MM-YYYY"));

    return (
      <>
        {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {!isHideSection && (
          <>
            {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ||
              JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 8 ? (
              <ExhibitorHeader />
            ) : (
              <HeaderWithLogo />
            )}
            {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ||
              JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 8 ? (
              <ExhibitorDrawer />
            ) : JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 7 ? (
              <VendorDrawer />
            ) : (
              <AdminDrawer />
            )}
          </>
        )}
        <div
          className={!isHideSection ? "with-dr-container mf-form" : ""}
          style={{ marginTop: !is_View ? "0px" : "" }}
        >
          <div className="">
            <div className="row">
              {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ||
                JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 8 ? (
                <ExhibitorTopMenu />
              ) : null}
            </div>
{/* Standard page title strip: form name + deadline, sticky under the tab bar */}
{!isHideSection && <ManualFormTitleStrip title={this.props.location?.state?.ManualFormsName || "Meeting Room Request"} deadline={this.props.location?.state?.ActualDeadline} />}

            <div className="">
              {/* Page view: no row padding / card margin (p-4 + m-1 put the card ~32px in, twice
                  the other manual forms) - the card sits on the mf-form 16px line */}
              <div className={!isHideSection ? "row m-0 mt-4" : "row p-2"}>
                <div className={!isHideSection ? "card rounded-0 border shadow-none m-0 p-0" : "card rounded-0 border shadow-none m-1 p-0"}>
                  <div class="card-header p-2 mf-old-title" style={{ paddingleft: "7px !important" }}>
                    <h3 class="card-title" style={{ fontsize: "15px" }}>
                      Meeting Room Request Form
                    </h3>
                  </div>
                  {!isHideSection &&
                    <p class="card-body p-1 m-2">
                      <ul
                        style={{
                          lineHeight: "25px",
                          textAlign: "left",
                          padding: 0,
                        }}
                      >
                        <li>
                          {" "}
                          1) As part of the venue facility, meeting rooms are made available for hire to the exhibitors at a basic price.
                        </li>
                        <li>
                          {" "}
                          2) Please find below the charges for booking the meeting rooms for your meetings or any other programs.{" "}
                        </li>
                        <li>
                          {" "}
                          3) Furnished meeting rooms will have a table, chairs, carpet, lighting, and a dustbin as standard furniture. Any additional requirements like AV, photography, etc. will be at actual cost by the official Service Partner.{" "}
                        </li>
                        <li>
                          {" "}
                          4) Tea, coffee, and cookies will be at actual cost, based on your requirement/menu.
                        </li>
                        <li>
                          {" "}
                          5) Allotment of meeting rooms is based on first come first serve basis upon submission of 100% payment & subject to availability.{" "}
                        </li>
                      </ul>
                      <p style={{ lineHeight: "25px" }}>
                        <p className="m-0">
                          <strong>Note:</strong>
                        </p>
                        <ul style={{ listStyleType: "disc" }}>
                          <li>
                            Last date of submission of application for the booking of meeting rooms with full payment is {moment(this.props.location?.state?.ActualDeadline || null).format('DD-MM-YYYY') || ''}.
                          </li>
                          <li>
                            Kindly make the 100% payment within 15 days from the date of the proforma invoice.
                          </li>
                          <li>
                            In case of last-minute cancellation, the Taxes paid and advance extended to the various service providers will be forfeited.{" "}
                          </li>
                          <li>
                            The following decorations are specifically prohibited at the venue, such as glitter, stickers, spray paint, liquid paint, burning objects, helium balloons, etc.
                          </li>
                          <ul style={{ listStyleType: "circle" }}>
                            <li>
                              a) No furniture or decorative objects belonging to ITME can be moved from their respective positions without the permission of the ITME.
                            </li>
                            <li>
                              b) Nothing may be nailed, tacked, taped, hung, stapled or affixed in any way to the facility, inside or out.
                            </li>
                          </ul>
                          <li>
                            If applicant’s Staff, volunteers, participants, invitees, licensees, or Vendor causes damage to India ITME Society’s or Venue Facilities and Equipment, applicant shall pay any costs associated with repairing the damage and restoring the Facilities and Equipment to their condition prior to applicant’s use thereof.
                          </li>
                          <li>
                            Liquor permits must be taken from the Government if served during meetings/ inside Exhibition Venue.
                          </li>
                          <li>
                            The applicant agrees to indemnify the Exhibition Authority and its Office-Bearers, Steering Committee Members, Executive Director, Officers, Employees and Members, and hold them and each of them harmless from and against any and all claims arising out of the acts of the exhibitor, his agents, representatives and employees, and all contractors, erectors, delivery persons, suppliers and material persons, furnishing services, delivery work or materials at the instance of the exhibitor.
                          </li>
                          <li>
                            All hostess/ support staff helping during meeting engaged by you shall apply for a proper venue entry pass.
                          </li>
                          <li>
                            Non-compliance with the above terms and conditions will result in cancellation of your booking as well as give full rights to the exhibition authority to take appropriate action legally or financially.
                          </li>
                        </ul>
                      </p>
                    </p>
                  }
                </div>

                <div class="table-responsive p-0">
                  <table className="table border text-nowrap text-md-nowrap table-bordered m-2 mt-1">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Room Type</th>
                        <th>Seating Capacity</th>
                        <th>Location</th>
                        <th>Slot</th>
                        <th style={{ textAlign: 'center' }}>Rate ({currency})</th>
                        <th style={{ textAlign: 'center' }}>Combo Slot Rate ({currency})</th>
                        <th style={{ textAlign: 'center' }}>Amount</th>
                      </tr>
                    </thead>

                    <tbody>
                      {this.state.meetingRoomsList.map((room, index) => {
                        const slot = room.timeSlot[0];

                        return (
                          <tr key={index}>
                            {room.date && (
                              <td rowSpan={room.dateRowSpan}>{room.date}</td>
                            )}

                            {room.RoomTypeName && (
                              <td rowSpan={room.roomTypeRowSpan}>
                                {room.RoomTypeName}
                              </td>
                            )}

                            {room.seatingCapacity && (
                              <td rowSpan={room.seatingRowSpan}>
                                {room.seatingCapacity}
                              </td>
                            )}

                            {room.location && (
                              <td rowSpan={room.locationRowSpan}>
                                {room.location}
                              </td>
                            )}

                            {/* <td>{slot.time}</td> */}

                            <td>
                              <input
                                type="checkbox"
                                checked={slot.selected}
                                disabled={is_View || isDeadlinePassed || StatusID == 2}
                                onChange={() => this.handleSlotChange(index)}
                              />
                              {" "}
                              {slot.time}
                            </td>

                            <td style={{ textAlign: 'right' }}>
                              {slot.originalRate}
                            </td>

                            {!slot.hideComboCell && (
                              <td rowSpan={slot.comboApplied ? slot.comboRowSpan : 1} style={{ textAlign: 'right', verticalAlign: 'middle' }}>
                                {slot.comboApplied && slot.comboRate > 0 ? slot.comboRate : '-'}
                              </td>
                            )}

                            {!slot.hideAmountCell && (
                              <td rowSpan={slot.amountRowSpan > 1 ? slot.amountRowSpan : 1} style={{ textAlign: 'right', verticalAlign: 'middle' }}>
                                {slot.selected ? slot.rate : 0}
                              </td>
                            )}
                          </tr>
                        );
                      })}

                      <tr>
                        <td colspan="6"></td>
                        <td style={{ textAlign: "right" }}>
                          <strong>Total</strong>
                        </td>
                        <td style={{ textAlign: "right" }}>
                          <strong>{formatAmount(totalAmount)}</strong>
                        </td>
                      </tr>
                      {!IsIGST ? (
                        <>
                          <>
                            <tr>
                              <td colspan="6"></td>
                              <td style={{ textAlign: "right" }}>
                                <strong>CGST @ {CGST}%</strong>
                              </td>
                              <td style={{ textAlign: "right" }}>
                                <strong>{formatAmount(CGST * totalAmount)}</strong>
                              </td>
                            </tr>
                            <tr>
                              <td colspan="6"></td>
                              <td style={{ textAlign: "right" }}>
                                <strong>SGST @ {SGST}%</strong>
                              </td>
                              <td style={{ textAlign: "right" }}>
                                <strong>{formatAmount(SGST * totalAmount)}</strong>
                              </td>
                            </tr>
                          </>

                        </>
                      ) : (
                        <>
                          <tr>
                            <td colspan="6"></td>
                            <td style={{ textAlign: "right" }}>
                              <strong>IGST @ {IGST}%</strong>
                            </td>
                            <td style={{ textAlign: "right" }}>
                              <strong>{formatAmount(IGST * totalAmount)}</strong>
                            </td>
                          </tr>
                        </>
                      )}
                      <tr style={{ backgroundcolor: "#eee" }}>
                        <td colspan="6"></td>
                        <td style={{ textAlign: "right" }}>
                          <strong>Grand Total</strong>
                        </td>
                        <td style={{ textAlign: "right" }}>
                          <strong>
                            {formatAmount(
                              (totalAmount * (1 + IGST)).toFixed(2)
                            )}
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="row m-1">
                  <form>
                    <strong>
                      {" "}
                      <label>Remark</label>
                    </strong>
                    <textarea
                      class="form-control"
                      value={Remark}
                      disabled={is_View || isDeadlinePassed || StatusID == 2}
                      onChange={(e) => this.setState({ Remark: e.target.value })}
                      maxLength={300}
                      rows="3"
                    ></textarea>
                    <label class="mt-1" style={{ lineheight: "15px;" }}>
                      <input
                        type="checkbox"
                        checked={Is_Agree}
                        disabled={is_View || isDeadlinePassed || StatusID == 2}
                        onChange={(e) =>
                          this.setState({
                            Is_Agree: e.target.checked,
                            Is_AgreeErr: "",
                          })
                        }
                      />
                      <strong>
                        I confirm the above requirements and disclaimer.
                        <span className="required">*</span>
                      </strong>
                    </label>
                    {
                      <span className="text-danger text-start text-left d-block mt-1">
                        {Is_AgreeErr}
                      </span>
                    }
                  </form>
                </div>
              </div>
              <div className="row">
                {isDeadlinePassed && (
                  <span className="text-danger">THE DEADLINE TO FILL OUT THE FORM HAS PASSED.</span>
                )}
              </div>
              {!isHideSection &&
                <div class="d-flex m-3">
                  {!is_View ? (
                    <button
                      type="button"
                      className="btn btn-aqua rounded-0 d-block mt-3 mb-3"
                      style={{ marginRight: 10 }}
                      disabled={isDeadlinePassed || StatusID == 2}
                      // onClick={() => this.insertUpdateMeetingRoom()}
                      onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to  ${this.state.StatusID == 0 ? "Submit" : "Update"}?`, buttonName: this.state.StatusID == 0 ? "Submit" : "Update", action: 0 }, popArg: [] })}
                    >
                      {this.state.StatusID == 0 ? "Submit" : "Update"}
                    </button>
                  ) : (
                    <></>
                  )}
                  <button
                    className="btn rounded-0 d-block mt-3 mb-3 btn-gray"
                    onClick={() => this.handleCancel()}
                  >
                    Back
                  </button>
                </div>
              }
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    getMeetingRoomDetails_action,
    insertUpdateMeetingRoom_action,
  })(MeetingRoomRequestForm)
);
